import {ImageBackground} from 'react-native';
import React from 'react';
import {createStyles} from '../../../utils/createStyles';
import WebviewCustomer from '../../../components/WebviewCustomer';
import {AIWebviewURL} from '../../../env/webviewUrl';
import {RouteParamsList} from '../../../router/ParamsList';
import {useRoute} from '@react-navigation/native';
import {RouteProp} from '@react-navigation/core/src/types';

export default function ChatRecordInfo(): React.JSX.Element {
  const route = useRoute<RouteProp<RouteParamsList, 'ChatRecordInfo'>>();
  const url = `${AIWebviewURL}/AI/chatInfo?chatRecordId=${route.params.chatRecordId}`;
  return (
    <ImageBackground
      style={styles.flex1}
      source={require('../../../assets/images/bg1.png')}>
      <WebviewCustomer style={{backgroundColor: 'transparent'}} url={url} />
    </ImageBackground>
  );
}
const styles = createStyles({
  flex1: {
    flex: 1,
  },
});
